import script from "./DeepReader.vue?vue&type=script&setup=true&lang=js"
export * from "./DeepReader.vue?vue&type=script&setup=true&lang=js"

import "./DeepReader.vue?vue&type=style&index=0&id=38030b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38030b90"]])

export default __exports__